import { render, staticRenderFns } from "./TypeConfig.vue?vue&type=template&id=a47e52bc&"
import script from "./TypeConfig.vue?vue&type=script&lang=js&"
export * from "./TypeConfig.vue?vue&type=script&lang=js&"
import style0 from "./TypeConfig.vue?vue&type=style&index=0&id=a47e52bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports